import React from "react"

import styles from "./CustomizeDeliveryPriceForm.module.scss"
import formattedPrice from "../shared/formatted_price";

function CustomizeDeliveryPriceForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { onChange, errors, selectedSlot, selectedDeliveryPrice } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------


  // -------------------------------------
  // Component functions
  // -------------------------------------

  function increasePrice() {
    onChange(selectedDeliveryPrice + 10)
  }

  function decreasePrice() {
    if (minimumPrice) {
      return;
    }

    onChange(selectedDeliveryPrice - 10)
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const showEditDeliveryPrice = !!selectedSlot && selectedSlot.vehicle_type !== "venue"
  const minimumPrice = !!selectedSlot && selectedDeliveryPrice === selectedSlot.price_cents;

  // -------------------------------------

  if (!showEditDeliveryPrice) {
    return null
  }

  return (
    <div className="delivery-address-form order-step">
      <h4>{I18n.t("pages.orders.new.customize_delivery_price")}</h4>
      <p
        className="checkout-info">{I18n.t("pages.orders.new.customize_delivery_price_min_price", { price: formattedPrice(selectedSlot.price_cents) })}</p>

      <div className="row">
        <div className="col-xs-1">
          <div onClick={decreasePrice}
               className={`${styles.button} ${minimumPrice ? styles.button__disabled : styles.button__enabled}`}>-
          </div>
        </div>

        <div className="col-xs-4 col-sm-2">
          <div className={styles.price}>{formattedPrice(selectedDeliveryPrice)}</div>
        </div>

        <div className="col-xs-1">
          <div onClick={increasePrice} className={`${styles.button} ${styles.button__enabled}`}>+</div>
        </div>
      </div>
    </div>
  )
}

export default CustomizeDeliveryPriceForm
